module.exports = __webpack_public_path__ + "static/wip-f2eba26f57b66e22f2c0bb7372c828fd.jpg";